import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'app-add-supplier-window',
  templateUrl: './add-supplier-window.component.html',
  styleUrls: ['./add-supplier-window.component.css']
})
export class AddSupplierWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/suppliers');
  }

}
